import { FunctionComponent, PropsWithChildren } from 'react';
import { Accordion } from 'react-bootstrap';
import { CustomAccordionBodyProps, CustomAccordionProps } from './types';

// eslint-disable-next-line
export const CustomAccordion: FunctionComponent<CustomAccordionProps> = (props: PropsWithChildren<CustomAccordionProps>) => {
    const {
        id,
        containerClassName,
        children,
    } = props;

    return (
        <div id={id} className={`${containerClassName ?? ''}`}>
            <Accordion defaultActiveKey='0' bsPrefix='wizard-accordion'>
                {children}
            </Accordion>
        </div>
    );
};

// eslint-disable-next-line
export const CustomAccordionBody: FunctionComponent<CustomAccordionBodyProps> = (props: PropsWithChildren<CustomAccordionBodyProps>) => {
    const {
        id,
        name,
        namePartTwo,
        namePartTwoClassName,
        namePartThree,
        namePartThreeClassName,
        eventKey,
        children,
        className,
    } = props;

    return (
        <Accordion.Item eventKey={eventKey} className='open'>
            <Accordion.Header id={id}>
                <span className='d-block lh-lg'>
                    <span className='d-block acd-title'>{name}</span>
                    {namePartTwo
                        ? (
                            <span className={`d-block ${namePartTwoClassName}`}>
                                {namePartTwo}
                            </span>
                        ) : null}
                    {namePartThree
                        ? (
                            <span className={`d-block fw-normal text-truncate pre-wrap ${namePartThreeClassName}`}>
                                {namePartThree}
                            </span>
                        ) : null}
                </span>
            </Accordion.Header>
            <Accordion.Body className={className}>
                {children}
            </Accordion.Body>
        </Accordion.Item>
    );
};
